import * as Yup from "yup";
import checkout from "./formNull";

const {
  formFieldNull: {
  },
} = checkout;

const validationNull = Yup.object().shape({

});

export default validationNull;
